'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _appStepRoutes = require('../../../core/constants/appStepRoutes');

var _Lazy = require('../../../core/routeHandlers/Lazy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (handleNext, handlePortalSelected) {
  return {
    route: _appStepRoutes.EXISTING_ACCOUNTS,
    handler: function handler(props) {
      return _react2.default.createElement(
        _react2.default.Suspense,
        { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
        _react2.default.createElement(_Lazy.ListOfExistingAccounts, props)
      );
    },
    expandedWidth: true,
    props: {
      handleCreateNewAccountClick: handleNext,
      handleHasNoAccounts: handleNext,
      handlePortalSelected: handlePortalSelected
    }
  };
};

module.exports = exports['default'];